import React, { useState, useRef, useEffect } from "react";
import { Badge, Form, Dropdown } from "react-bootstrap";

const MultiGenreSelect = ({
  genres,
  selectedGenres = [],
  onChange,
  placeholder = "Select Genres (Optional)",
  size = "sm",
  disabled = false
}) => {
  const [show, setShow] = useState(false);

  const handleToggleGenre = (genreName) => {
    const newSelected = selectedGenres.includes(genreName)
      ? selectedGenres.filter((g) => g !== genreName)
      : [...selectedGenres, genreName];
    onChange(newSelected);
  };

  const handleRemoveGenre = (genreName, e) => {
    e.stopPropagation();
    onChange(selectedGenres.filter((g) => g !== genreName));
  };

  return (
    <Dropdown
      show={disabled ? false : show}
      onToggle={(isOpen) => !disabled && setShow(isOpen)}
      className="w-100 d-block"
      style={{ width: "100%", display: "block" }}
    >
      <Dropdown.Toggle
        variant="outline-secondary"
        size={size}
        className="w-100 d-flex justify-content-between align-items-center text-start"
        disabled={disabled}
        style={{
          backgroundColor: 'white',
          minHeight: size === 'sm' ? '31px' : '38px',
          whiteSpace: 'normal',
          paddingRight: '12px',
          width: '100%',
          display: 'flex'
        }}
      >
        {selectedGenres.length === 0 ? (
          <span className="text-muted">{placeholder}</span>
        ) : (
          <div
            className="d-flex flex-wrap gap-1"
            style={{ maxWidth: '100%', minWidth: 0 }}
          >
            {selectedGenres.map((genre) => (
              <Badge
                key={genre}
                bg="primary"
                className="me-1"
                style={{ cursor: 'pointer', fontSize: '0.75rem' }}
                onClick={(e) => handleRemoveGenre(genre, e)}
              >
                {genre} ×
              </Badge>
            ))}
          </div>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{
          maxHeight: '200px',
          overflowY: 'auto',
          width: '100%',
          minWidth: '100%'
        }}
      >
        {genres.map((genre) => (
          <Dropdown.Item
            key={genre._id}
            as="div"
            onClick={(e) => {
              e.stopPropagation();
              handleToggleGenre(genre.genreName);
            }}
            style={{ cursor: 'pointer' }}
          >
            <Form.Check
              type="checkbox"
              checked={selectedGenres.includes(genre.genreName)}
              onChange={() => {}}
              label={genre.genreName}
              style={{ pointerEvents: 'none' }}
            />
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default MultiGenreSelect;
